import CmlBillingHeaderIndex from "@/components/billing_cml/billing/header/BillingHeaderIndex.vue";
import CmlBillingHeaderBASF01Index from "@/components/billing_cml/billing/header/BillingHeaderBASF01Index.vue";
import CmlBillingHeaderBASF02RMIndex from "@/components/billing_cml/billing/header/BillingHeaderBASF02RMIndex.vue";
import CmlBillingHeaderBASF02FGIndex from "@/components/billing_cml/billing/header/BillingHeaderBASF02FGIndex.vue";
import CmlBillingHeaderCreate from "@/components/billing_cml/billing/header/BillingHeaderCreate.vue";
import CmlBillingHeaderDetail from "@/components/billing_cml/billing/header/BillingHeaderDetail.vue";
import CmlBillingHeaderEdit from "@/components/billing_cml/billing/header/BillingHeaderEdit.vue";
import CmlBillingDetailStorage from "@/components/billing_cml/billing/detail_storage/BillingDetailStorageIndex.vue";
import CmlBillingDetailHandling from "@/components/billing_cml/billing/detail_handling/BillingDetailHandlingIndex.vue";
import CmlBillingSubDetailStorage from "@/components/billing_cml/billing/detail_sub_storage/BillingSubDetailStorageIndex.vue";
import CmlBillingDetailHandlingIn from "@/components/billing_cml/billing/detail_handling_in/BillingHandlingInIndex.vue";
import CmlBillingDetailHandlingInAdditional from "@/components/billing_cml/billing/detail_handling_in_additional/BillingHandlingInAdditionalIndex.vue";
import CmlBillingDetailHandlingOut from "@/components/billing_cml/billing/detail_handling_out/BillingHandlingOutIndex.vue";
import CmlBillingDetailEquipmentType from "@/components/billing_cml/billing/detail_equipment_type/BillingEquipmentTypeIndex.vue";
import CmlBillingDetailHandlingOutAdditional from "@/components/billing_cml/billing/detail_handling_out_additional/BillingHandlingOutAdditionalIndex.vue";
import CmlBillingDetailEquipmentTypeAdditional from "@/components/billing_cml/billing/detail_equipment_type_additional/BillingEquipmentTypeAdditionalIndex.vue";
import CmlBillingDetailOvertime from "@/components/billing_cml/billing/detail_overtime/BillingOvertimeIndex.vue";
import CmlBillingDetailExtraHandling from "@/components/billing_cml/billing/detail_extra_handling/BillingExtraHandlingIndex.vue";
import CmlBillingDetailVas from "@/components/billing_cml/billing/detail_vas/BillingVasIndex.vue";
import CmlBillingDetailRentalPallet from "@/components/billing_cml/billing/detail_rental_pallet/BillingRentalPalletIndex.vue";
import CmlBillingDetailMinimumCharge from "@/components/billing_cml/billing/detail_minimum_charge/BillingMinimumChargeIndex.vue";
import CmlBillingDetailSummaryHandlingCharge from "@/components/billing_cml/billing/detail_summary_handling_charge/BillingDetailSummaryHandlingChargeIndex.vue";
import CmlBillingDetailSummaryStorageMultiWh from "@/components/billing_cml/billing/detail_summary_storage_multiwh/BillingDetailSummaryStorageMultiWhIndex.vue";
import CmlBillingDetailSummaryStorageMuid from "@/components/billing_cml/billing/detail_summary_storage_muid/BillingDetailSummaryStorageMuidIndex.vue";
import CmlBillDetSummStrgQty from "@/components/billing_cml/billing/det_sum_strg_qty/BillDetSumStrgQtyIndex.vue";
import CmlBillingDetailSumStrgPltUsed from "@/components/billing_cml/billing/detail_summary_storage_pltused/BillingDetailSumStrgPltUsedIndex.vue";
import CmlBillingDetailDataSAP from "@/components/billing_cml/billing/detail_data_sap/BillingDetailDataSAPIndex.vue";
import CmlBillDetDataAkumActivity from "@/components/billing_cml/billing/detail_data_akum_activity/BillDetDataAkumActivityIndex.vue";
import CmlBillingLogsSyncTrx from "@/components/billing_cml/billing/detail_logs_sync_trx/BillingLogsSyncTrxIndex.vue";

let routesCmlBillingAccess= [
    {
        path: 'header',
        meta: {
          title: "CML List Billing Header",
        },
        name: "CmlBillingHeaderIndex",
        component: CmlBillingHeaderIndex
    },
    {
        path: 'header/BASF01',
        meta: {
          title: "CML List Billing Header BASF01",
        },
        name: "CmlBillingHeaderBASF01Index",
        component: CmlBillingHeaderBASF01Index
    },
    {
        path: 'header/BASF02RM',
        meta: {
          title: "CML List Billing Header BASF02 RM",
        },
        name: "CmlBillingHeaderBASF02RMIndex",
        component: CmlBillingHeaderBASF02RMIndex
    },
    {
        path: 'header/BASF02FG',
        meta: {
          title: "CML List Billing Header BASF02 FG",
        },
        name: "CmlBillingHeaderBASF02FGIndex",
        component: CmlBillingHeaderBASF02FGIndex
    },
    {
        path: 'header/create',
        meta: {
            title: "CML Create Billing Header",
        },
        name: "CmlBillingHeaderCreate",
        component: CmlBillingHeaderCreate
    },
    {
        path: 'header/detail/:id',
        meta: {
            title: "CML Detail Billing Header",
        },
        name: "CmlBillingHeaderDetail",
        component: CmlBillingHeaderDetail
    },
    {
        path: 'header/edit/:id',
        meta: {
            title: "CML Edit Billing Header",
        },
        name: "CmlBillingHeaderEdit",
        component: CmlBillingHeaderEdit
    },
    {
        path: 'detail-storage/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Billing Detail Storage",
        },
        name: "CmlBillingDetailStorage",
        component: CmlBillingDetailStorage
    },
    {
        path: 'detail-handling/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Billing Detail Handling",
        },
        name: "CmlBillingDetailHandling",
        component: CmlBillingDetailHandling
    },
    {
        path: 'detail-sub-storage/:idDetailStorage/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Sub Storage",
        },
        name: "CmlBillingSubDetailStorage",
        component: CmlBillingSubDetailStorage
    },
    {
        path: 'detail-handling-in/:idBillingDetail/:idBillingHeader/:idDetailHandling',
        meta: {
            title: "CML Detail Billing Handling In",
        },
        name: "CmlBillingDetailHandlingIn",
        component: CmlBillingDetailHandlingIn
    },
    {
        path: 'detail-handling-in-additional/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Handling In Additional",
        },
        name: "CmlBillingDetailHandlingInAdditional",
        component: CmlBillingDetailHandlingInAdditional
    },
    {
        path: 'detail-handling-out/:idBillingDetail/:idBillingHeader/:idDetailHandling',
        meta: {
            title: "CML Detail Billing Handling Out",
        },
        name: "CmlBillingDetailHandlingOut",
        component: CmlBillingDetailHandlingOut
    },
    {
        path: 'detail-equipment-type/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Equipment Type",
        },
        name: "CmlBillingDetailEquipmentType",
        component: CmlBillingDetailEquipmentType
    },
    {
        path: 'detail-handling-out-additional/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Handling Out Additional",
        },
        name: "CmlBillingDetailHandlingOutAdditional",
        component: CmlBillingDetailHandlingOutAdditional
    },
    {
        path: 'detail-equipment-type-additional/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Equipment Type Additional",
        },
        name: "CmlBillingDetailEquipmentTypeAdditional",
        component: CmlBillingDetailEquipmentTypeAdditional
    },
    {
        path: 'detail-handling-overtime/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Overtime",
        },
        name: "CmlBillingDetailOvertime",
        component: CmlBillingDetailOvertime
    },
    {
        path: 'detail-handling-extra/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Extra Handling",
        },
        name: "CmlBillingDetailExtraHandling",
        component: CmlBillingDetailExtraHandling
    },
    {
        path: 'detail-handling-vas/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Vas",
        },
        name: "CmlBillingDetailVas",
        component: CmlBillingDetailVas
    },
    {
        path: 'detail-handling-rental-pallet/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Rental Pallet",
        },
        name: "CmlBillingDetailRentalPallet",
        component: CmlBillingDetailRentalPallet
    },
    {
        path: 'detail-handling-minimum-charge/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Minimum Charge",
        },
        name: "CmlBillingDetailMinimumCharge",
        component: CmlBillingDetailMinimumCharge
    },
    {
        path: 'detail-summary-handling-charge/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Summary Handling Charge",
        },
        name: "CmlBillingDetailSummaryHandlingCharge",
        component: CmlBillingDetailSummaryHandlingCharge
    },
    {
        path: 'detail-summary-storage-multiwh/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Summary Storage Multi Warehouse",
        },
        name: "CmlBillingDetailSummaryStorageMultiWh",
        component: CmlBillingDetailSummaryStorageMultiWh
    },
    {
        path: 'detail-summary-storage-muid/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Summary Storage Muid",
        },
        name: "CmlBillingDetailSummaryStorageMuid",
        component: CmlBillingDetailSummaryStorageMuid
    },
    {
        path: 'det-sum-strg-qty/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Summary Storage Qty",
        },
        name: "CmlBillDetSummStrgQty",
        component: CmlBillDetSummStrgQty
    },
    {
        path: 'detail-summary-storage-pltused/:idBillingDetail/:idBillingHeader',
        meta: {
            title: "CML Detail Billing Summary Storage Pallet Used",
        },
        name: "CmlBillingDetailSumStrgPltUsed",
        component: CmlBillingDetailSumStrgPltUsed
    },
    {
        path: 'detail-data-sap/:id',
        meta: {
            title: "CML Detail Data SAP",
        },
        name: "CmlBillingDetailDataSAP",
        component: CmlBillingDetailDataSAP
    },
    {
        path: 'detail-data-akum-activity/:id',
        meta: {
            title: "CML Detail Data Akumulasi Activity",
        },
        name: "CmlBillDetDataAkumActivity",
        component: CmlBillDetDataAkumActivity
    },
    {
        path: 'detail-logs-sync-trx/:id',
        meta: {
            title: "CML Detail Logs Sync Trx",
        },
        name: "CmlBillingLogsSyncTrx",
        component: CmlBillingLogsSyncTrx
    },
    
]

export default routesCmlBillingAccess
  